const keys = {
  all: () => ["weather-overview"] as const,
  overview: (areaId: string) => [...keys.all(), areaId] as const,
};

export default keys;
